import React from 'react';
import { LineChartGoals } from '../LineChartGoals';
import { BarChartGoals } from '../BarChartGoals';

interface GoalChartProps {
  data: any;
  selectedTeam: string;
  showLabel: boolean;
}

const GoalChart: React.FC<GoalChartProps> = ({
  data,
  selectedTeam,
  showLabel,
}) => {
  switch (data?.chartMetadata?.chartType) {
    case 'line_chart':
      return (
        <LineChartGoals
          data={data?.data}
          keys={data?.keys}
          chartMetadata={data?.chartMetadata}
          selectedTeam={selectedTeam}
          showLabel
        />
      );
    case 'stacked_bar_chart':
      return (
        <BarChartGoals
          data={data?.data}
          keys={data?.keys}
          chartMetadata={data?.chartMetadata}
        />
      );

    default:
      return null;
  }
};

export default GoalChart;
